import * as R from 'ramda';
// constants
import * as C from '../../../constants';
import * as U from '../../../utilities';
// ui
import { Box, Flex } from '../../../ui';
// component virtualized table
import { stickedRightStyles } from '../settings';
import {
  DateCell,
  BooleanCell,
} from './default-cells';
////////////////////////////////////////////////

const componentsMap = {
  [C.FIELD_NAME]: null,
  // dates
  [C.FIELD_ADD_DATE]: DateCell,
  [C.FIELD_MCS150DATE]: DateCell,
  // boolean
  [C.FIELD_US_MAIL]: BooleanCell,
  [C.FIELD_HM_FLAG]: BooleanCell,
  [C.FIELD_PC_FLAG]: BooleanCell,
  [C.FIELD_MIGRANT]: BooleanCell,
  [C.FIELD_IS_EXISTS]: BooleanCell,
  [C.FIELD_PRIVATE_ONLY]: BooleanCell,
  [C.FIELD_INDIAN_TRIBE]: BooleanCell,
  [C.FIELD_IS_NEW_STATUS]: BooleanCell,
  [C.FIELD_EXEMPT_FOR_HIRE]: BooleanCell,
  [C.FIELD_PRIVATE_PROPERTY]: BooleanCell,
  [C.FIELD_STATE_GOVERNMENT]: BooleanCell,
  [C.FIELD_LOCAL_GOVERNMENT]: BooleanCell,
  [C.FIELD_FEDERAL_GOVERNMENT]: BooleanCell,
  [C.FIELD_AUTHORIZED_FOR_HIRE]: BooleanCell,
  [C.FIELD_PRIVATE_PASSENGER_BUSINESS]: BooleanCell,
  [C.FIELD_PRIVATE_PASSENGER_NONBUSINESS]: BooleanCell,
};

const ResultRow = props => {
  const {
    data,
    style,
    deleted,
    handlers,
    itemSize,
    columnSettings,
    notAllowActions,
  } = props;

  const { id, highlighted } = data;

  const backgroundColor = highlighted ? 'linkColor' : 'white';

  const justifyRow = U.ifElse(R.gt(itemSize, 49), 'flex-start', 'center');

  return (
    <Flex
      {...style}
      minWidth='100%'
      width='fit-content'
      borderBottom='none'
      bg={backgroundColor}
      height={R.dec(itemSize)}
    >
      {
        columnSettings.map(({
          name,
          path,
          width,
          stickedRight,
        }) => {
          const CellComponent = R.path([name], componentsMap);

          const additionalStyles = stickedRight ? stickedRightStyles : {};
          const cellValue = R.path(R.split('.', name), data);

          return (
            <Box
              {...additionalStyles}
              height='100%'
              width={width}
              bg={backgroundColor}
              key={`search-results-row-${id}-cell-${name}`}
              title={U.cleanStringFromLinesAndSpaces(cellValue)}
            >
              <Flex
                p='8px'
                height='100%'
                fontSize={13}
                position='relative'
                flexDirection='column'
                alignItems='flex-start'
                justifyContent={justifyRow}
              >
                {
                  CellComponent
                    ? (
                      <CellComponent
                        data={data}
                        name={name}
                        width={width}
                        deleted={deleted}
                        handlers={handlers}
                        path={R.or(path, [])}
                        notAllowActions={notAllowActions}
                      />
                    )
                    : U.capitalizeEveryFirstStrCharacter(cellValue)
                }
              </Flex>
            </Box>
          );
        })
      }
    </Flex>
  );
};

export default ResultRow;
